// extracted by mini-css-extract-plugin
module.exports = {"answerTitle":"styles_answerTitle__OZ49y","titleAnswered":"styles_titleAnswered__mCt_3"};